/**
 * "▲ 4 pts" / "▼ 1 pt": the move as a quote, its figure in tabular type; "No change" as is.
 * @param {{text: string}} props an answerSummary change's `text` ("+4 pts", "−1 pt")
 */
export default function ChangeText({ text }) {
  const m = /^([+−])(\d+)(.*)$/.exec(text || "");
  if (!m) return <span>{text}</span>;
  return (
    <span>
      <span className="sy-num">
        {m[1] === "+" ? "▲" : "▼"} {m[2]}
      </span>
      {m[3]}
    </span>
  );
}
